<template>
  <div class="p-b-3">
    <job-request-pane>
      <template slot="title">
        What stage is your project in?
      </template>
      <template slot="content">
        <urgency v-model="selectedUrgency" @input="focusNotes"/>
      </template>
    </job-request-pane>

    <!-- Notes and Files Section -->
    <div ref="notes-heading" class="container p-x-2:mo m-b-6">
      <job-request-section-heading>
        Do you have anything else to share? (optional)
      </job-request-section-heading>

      <div class="layout gap-3 m-b-3">

        <!-- Notes -->
        <div class="layout-item is-10 is-12:mo">
          <notes ref="notes" v-model="notes"/>
        </div>

      </div>
      <!-- File Upload -->
      <div class="layout-item is-3 is-12:mo">
        <image-upload
            :max-file-count="$options.MAX_FILE_COUNT"
            :namespace="$options.NAMESPACE"
            v-model="uploadedImages"
            selenium="upload-photo-input"/>
      </div>
      <photo-info/>
    </div>

    <div class="container p-x-2:mo">
      <div
          class="d-flex jc-end"
          :class="{'CONTINUE': !$device.isMobile && hasSmallViewport}">
        <router-link
            :to="{
              name: 'jobrequest::matches',
              params: $route.params,
              query: $route.query,
            }"
            :disabled="!isValid"
            class="btn btn-large w-100:mo"
            selenium="show-my-pros-button">
          Continue
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import JobRequestPane from '@/views/JobRequest/components/JobRequestPane';
import JobRequestSectionHeading from '@/views/JobRequest/components/JobRequestSectionHeading';
import PhotoInfo from '@/components/PhotoInfo';
import Urgency from './components/Urgency';
import Notes from './components/Notes';

const MAX_FILE_COUNT = 15;
const NAMESPACE = 'work-orders-consumer-request';

export default {
  name: 'job-details',
  MAX_FILE_COUNT,
  NAMESPACE,
  components: {
    JobRequestPane,
    JobRequestSectionHeading,
    Urgency,
    Notes,
    PhotoInfo,
  },
  computed: {
    ...mapGetters('jobrequest/details', ['isValid']),
    hasSmallViewport () {
      return window.outerWidth < 500;
    },
    selectedUrgency: {
      get () {
        return this.$store.getters['jobrequest/details/selectedUrgencyId'];
      },
      set (value) {
        this.$store.dispatch('jobrequest/details/setSelectedUrgencyId', value);
      },
    },
    notes: {
      get () {
        return this.$store.getters['jobrequest/details/notes'];
      },
      set (value) {
        this.$store.dispatch('jobrequest/details/setNotes', value);
      },
    },
    uploadedImages: {
      get () {
        return this.$store.getters['jobrequest/details/uploadedImages'];
      },
      set (value) {
        this.$store.dispatch('jobrequest/details/setUploadedImages', value);
      },
    },
  },
  methods: {
    focusNotes () {
      this.$refs.notes.focus({ preventScroll: true });

      if (this.$device.isMobile) {
        this.$refs['notes-heading'].scrollIntoView();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.CONTINUE {
  margin-right: $unit * 6;
}
</style>
